<template>
  <div>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
      <v-spacer />
    </div>

    <v-flex xs12>
      <v-data-table
        v-if="table.outgoingCategories.data.length"
        :loading-text="table.outgoingCategories.title"
        :server-items-length="table.outgoingCategories.total"
        :loading="table.outgoingCategories.loading"
        :headers="table.outgoingCategories.headers"
        :items="table.outgoingCategories.data"
        :options="table.outgoingCategories.options"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50]
        }"
        sort-by="name"
        @update:options="updateCategoriesTable"
        class="elevation-1">
        <template v-slot:[`header.cashflowType`]="{ header }">
          <span>{{ header.text }}</span>
          <ButtonHeader
            v-if="expensesPermissions['update-outgoing-type']"
            @click="openAddTypeDialog()"
          >
            <v-icon x-small>mdi-pencil</v-icon>
          </ButtonHeader>
        </template>
        <template v-slot:[`item.cashflowType`]="{ item }">
          <div>{{ (item.concept && item.concept.type) ? item.concept.type.name : undefined }}</div>
        </template>
        <template v-slot:[`header.concept`]="{ header }">
          <span>{{ header.text }}</span>
          <ButtonHeader
            v-if="expensesPermissions['update-outgoing-concept']"
            @click="openAddConceptDialog()"
          >
            <v-icon x-small>mdi-pencil</v-icon>
          </ButtonHeader>
        </template>
        <template v-slot:[`item.concept`]="{ item }">
          <div>{{ item.concept && item.concept.name }}</div>
        </template>
        <template v-slot:[`header.name`]="{ header }">
          <span>{{ header.text }}</span>
          <ButtonHeader v-if="expensesPermissions['create-outgoing-category']"
            @click="openAddCategoryDialog()"
          >
            <v-icon x-small>mdi-plus</v-icon>
          </ButtonHeader>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <div>{{ item.name }}</div>
        </template>
        <template v-slot:[`item.action`]="{ item }" v-if="expensesPermissions['update-outgoing-category']">
          <div>
            <v-btn
              v-if="expensesPermissions['update-outgoing-category']"
              fab
              color="primary"
              x-small
              depressed
              @click="openAddCategoryDialog({
                _id: item._id,
                concept: item.concept ? item.concept._id : '',
                type: (item.concept && item.concept.type) ? item.concept.type._id : '',
                name: item.name
              })"
              class="mr-2"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
      <div
        v-else
        class="pa-3 grey lighten-4"
        >
        <div class="d-flex justify-center mt-6">
          <v-row
            align="center"
            justify="center">
            <v-icon
              size="150"
              color="primary">
              mdi-cogs
            </v-icon>
            <v-col cols="4">
              <div class="grey--text">
                <div
                  class="title mb-3 font-weight-bold">
                  Aún no tienes cofigurada ninguna categoría de egreso.
                </div>
                <div class="subtitle-2">
                  <div class="mb-3">
                    Crea alguna para poder tener un control de tus egresos.
                  </div>
                  <div>
                    <a class="primary--text" href="#" @click.prevent="openAddCategoryDialog()" v-if="expensesPermissions['create-outgoing-category']">Crear una categoría de egreso</a>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-flex>

    <AddCategory
      ref="addCategory"
      @updated="loadCategories"
    />

    <AddOutgoingConcept
      ref="addConcept"
      @updated="loadCategories"
    />

    <AddOutgoingType
      ref="addType"
      @updated="loadCategories"
    />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import AddCategory from '@/components/modals/AddOutgoingCategory'
import AddOutgoingConcept from '@/components/modals/AddOutgoingConcept'
import AddOutgoingType from '@/components/modals/AddOutgoingType'
import ButtonHeader from '@/components/elements/ButtonHeader'

export default {
  name: 'OutgoingCategories',
  components: {
    AddCategory,
    AddOutgoingConcept,
    AddOutgoingType,
    ButtonHeader
  },
  data () {
    return {
      overlay: false,
      section: this.$i18n.t('expenses.outgoingCategories.section'),
      table: {
        outgoingCategories: {
          title: this.$i18n.t('expenses.outgoingCategories.loading'),
          loading: true,
          headers: [
            { text: 'Tipo de egreso', value: 'cashflowType' },
            { text: 'Concepto de egreso', value: 'concept' },
            { text: 'Categoría de egreso', value: 'name' },
            { text: '', value: 'action' }
          ],
          data: [],
          total: 0,
          options: {
            groupBy: [],
            groupDesc: [],
            itemsPerPage: 50,
            multiSort: false,
            mustSort: false,
            page: 1,
            sortBy: [''],
            sortDesc: []
          }
        }
      },
      tab: 0
    }
  },
  watch: {
    restaurant: {
      handler: async function () {
        await this.loadCategories()
      },
      deep: true
    }
  },
  computed: {
    expensesPermissions () {
      return this.$store.state.login.permissions['expenses'].components['outgoing-category'].actions
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data
    }
  },
  async mounted () {
    await this.loadCategories({
      type: 'outgoing',
      restaurant: this.$store.state.currentRestaurant.data._id
    })
  },
  methods: {
    openAddCategoryDialog: function (item) {
      this.$refs.addCategory.openDialog(item)
    },
    updateCategoriesTable: async function (data) {
      // const { sortBy, sortDesc } = data
      this.table.outgoingCategories.options = data
      if (this.$store.state.area) {
        await this.loadCategories({
          type: 'outgoing',
          restaurant: this.$store.state.currentRestaurant.data._id,
          sort: data.sortDesc[0] ? data.sortBy[0] : `-${data.sortBy[0] || 'name'}`,
          limit: data.itemsPerPage,
          skip: (data.itemsPerPage * (data.page - 1))
        })
      }
    },
    async loadCategories (params = null) {
      params = params || {
        type: 'outgoing',
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.table.outgoingCategories.loading = true
      try {
        const response = await this.$api.get(`/v1/cashflows`, params)
        this.table.outgoingCategories.data = response.data
        this.table.outgoingCategories.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.outgoingCategories.loading = false
    },
    openAddConceptDialog (concept) {
      this.$refs.addConcept.openDialog(concept)
    },
    openAddTypeDialog (type) {
      this.$refs.addType.openDialog(type)
    }
  }
}
</script>
